<template>
  <InputComponent
    v-if="$path('quantity.enabled', value)"
    v-model="valueComp"
    align="center"
    class="shop-product-quantity"
    :class="{ 'shop-product-quantity--readonly': readonly }"
    :readonly="readonly"
    :title="`${min} - ${max}`"
    :suffix="$t('piecesShort')"
    type="number"
  >
    <template #left>
      <button
        v-if="!readonly"
        type="button"
        :disabled="valueComp === min"
        @click.stop="valueComp--"
      >
        <Icon icon="fa-pro-solid:minus" />
      </button>
    </template>
    <template #right>
      <button
        v-if="!readonly"
        type="button"
        :disabled="valueComp === max"
        @click.stop="valueComp++"
      >
        <Icon icon="fa-pro-solid:plus" />
      </button>
    </template>
  </InputComponent>
</template>

<script>
import { InputComponent } from 'vue-elder-input'
import Icon from '@kvass/vue2-icon'

export default {
  inject: {
    getItemStatus: { default: null },
  },
  props: {
    value: Object,
  },
  computed: {
    readonly() {
      return !this.status.isSelectable
    },
    min() {
      return this.$path('value.quantity.min') || 1
    },
    max() {
      return this.$path('value.quantity.max') || Infinity
    },
    valueComp: {
      get() {
        return this.$path('value.quantity.value') || this.min
      },
      set(val) {
        const value = Math.min(Math.max(this.min, val), this.max)
        if (value === this.valueComp) return

        this.$emit('change', value)
      },
    },
    status() {
      if (!this.getItemStatus) return {}
      return this.getItemStatus(this.value.id)
    },
  },
  components: {
    Icon,
    InputComponent,
  },
}
</script>

<style lang="scss">
.shop-product-quantity {
  --spacing-x: 0.5rem;
  --spacing-y: 0.25rem;

  border: 1px solid var(--border-color);
  border-radius: var(--border-radius);
  overflow: clip;

  .elder-input__field {
    border: none;

    border-radius: initial;
    margin: 0;
  }

  &:not(&--readonly) {
    .elder-input__field {
      border-left: 1px solid var(--border-color);
      border-right: 1px solid var(--border-color);
    }

    .elder-input__suffix {
      display: none;
    }
  }

  button {
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    padding: var(--spacing-y) var(--spacing-x);

    &:hover,
    &:focus-within {
      background-color: hsla(var(--primary-h), var(--primary-s), var(--primary-l), 0.05);
    }

    &:focus-within {
      outline: 1px solid var(--primary);
    }

    &:disabled {
      cursor: not-allowed;
      background-color: rgba(black, 0.05);
    }
  }

  input {
    padding-block: var(--spacing-y);
    padding-inline: 0;
    max-width: calc(4ch + var(--spacing-x) * 2);
  }

  .elder-input__suffix {
    display: flex;
    align-items: center;
    padding-block: 0;
    padding-inline: var(--spacing-x);
    font-weight: normal;
  }
}
</style>
